import { extraNetworkActionsCreator } from '../../../../admincore'

const actions = {
  ...extraNetworkActionsCreator('DESTROY', 'people/destroy'),
}

export default actions

export function destroy(id) {
  return {
    type: actions.DESTROY,
    payload: {
      id,
    },
  }
}
